export const convertLabelsToTranslate = (data) => {
  const translatedData = data.reduce(
    (translatedData, item) => ({
      ...translatedData,
    [item.label]: item.value,
    [item.label.charAt(0).toUpperCase() + item.label.slice(1)]: item.value,
    [item.label.toUpperCase()]: item.value.toUpperCase(),
    [item.label.toLowerCase()]: item.value.toLowerCase(),
    }),
    {},
  );
  return translatedData;
};

export const labelsTranslate = () => {
  const dataTranslate = ['Agregado', 'Implemento', 'Caminhão', 'Moto', 'Carro'];
  return dataTranslate.map((item) => ({
    [item]: item,
    [item.toUpperCase()]: item.toUpperCase(),
    [item.toLowerCase()]: item.toLowerCase(),
  }));
};
